import {FC} from 'react';
import {useTranslation} from 'react-i18next';

type DetailedDescriptionProps = {
  detailedDesc: string
}

const DetailedDescription: FC<DetailedDescriptionProps> = ({
  detailedDesc
}) => {
  const {t} = useTranslation(['tasks']);

  const detailedDescription = detailedDesc?.split(';');

  if (!detailedDescription?.length) {
    return null;
  }

  return (
    <section className="task-description__section">
      <h4 className="title">{t('currentTask.description.popup.rulesLabel')}</h4>
      <ul className="task-description__list">
        {detailedDescription.map((descriptionItem, index) => (
          <li
            key={index.toString()}
            className="task-description__item"
          >
            {descriptionItem}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default DetailedDescription;
